module.exports = __webpack_public_path__ + "media/src/application/media/img1-c626ed6649f3b8ed107b4b6d4d6fdf15.jpg";